// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "fe75db45" + "." + "7fe8cc7a3eb5f7eb" + ".js";
};